export type TFilter = number | string | IRange

export interface IRange<T = number | string> {
	from: T;
	to?: T;
}

export interface IFilters<T extends TFilter = TFilter> {
	values?: Array<T>;
	ranges?: Array<T>;
	key: string;
}

export enum FilterKeys {
	DURATION = 'duration',
	DEPARTUREDATE = 'departureDateTime',
	DESTINATION = 'destinationId',
	CRUISELINE = 'cruiselineId',
	SHIP = 'shipId',
	DEPARTUREPORT = 'departurePortCode',
}

export interface OdesseusSelectOption<T = null> {
	name: string;
	value: number | string;
	raw?: T;
}

export interface OdesseusOptions {
	destinations: Array<OdesseusSelectOption>;
	ports: Array<OdesseusSelectOption>;
	cruiselines: Array<OdesseusSelectOption>;
	ships: Array<OdesseusSelectOptionGroup>;
	dates: Array<OdesseusSelectOption<IRange<number>>>;
	durations: Array<OdesseusSelectOption<IRange<number>>>;
}

export interface ResultFilters {
	options: OdesseusOptions;
	loading: boolean;
}

export interface OdesseusSelectOptionGroup {
	title: string;
	options: Array<OdesseusSelectOption>;
}

export interface OdesseusSelectWithParent {
	name: string;
	value: number | string;
	parentId: number;
}
